import { render } from "./HospitalHeader.vue?vue&type=template&id=03f8bbe4&scoped=true&ts=true"
import script from "./HospitalHeader.vue?vue&type=script&lang=ts"
export * from "./HospitalHeader.vue?vue&type=script&lang=ts"

import "./HospitalHeader.vue?vue&type=style&index=0&id=03f8bbe4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f8bbe4"]])

export default __exports__